<template>
  <div id="qa-tree-container" class="qa-tree-container">
    <!-- <div style="position: absolute; z-index: 1000" @click="draw(demo)">111</div> -->

    <nodes-preview :node-list="nodeList" />
    <canvas-zoom
      :graph="xGraph"
      handle-click-layout
      @handlerSave="handlerSave"
      @handleClickLayout="handleClickLayout"
      @centerGraph="centerGraph"
    />
    <div id="qa-tree-g6" ref="painter"></div>
    <!-- <div class="layout-button">
      <button class="button" @click="toggleEdgeType">🎡</button>
      <button class="button" @click="centerGraph">🔲</button>
      <button class="button" @click="handleClickLayout(true)">🗂️</button>
      <button class="button" @click="handlerSave">🗄️</button>
    </div> -->
    <edit-node-component
      ref="editNode"
      :node-list="nodeList"
      @submit="handlerEditNodeSubmit"
      @close="handlerEditNodeDialogClose"
    ></edit-node-component>
    <!-- <div class="operation">
      <t-button shape="square" variant="text" @click="handleClickLayout(true)">
        <template #icon><GestureApplauseIcon /></template>
      </t-button>
      <t-button shape="square" variant="text" @click="centerGraph">
        <template #icon><CenterFocusStrongIcon /></template>
      </t-button>
      <t-button shape="square" variant="text" @click="handlerSave">
        <template #icon><SaveIcon /></template>
      </t-button>
    </div> -->
  </div>
</template>

<script>
import {
  debounce,
  get,
  toInteger,
  random,
  merge,
  unset,
  cloneDeep,
  fromPairs,
  map,
  uniq,
  trim,
} from "lodash-es";
import {
  registerBehavior as g6registerBehavior,
  Graph as g6Graph,
  Tooltip as g6Tooltip,
  Menu as g6Menu,
  Minimap as g6Minimap,
  registerNode as g6registerNode,
  registerEdge as g6registerEdge,
} from "@antv/g6/es";
import { getEdgeDefineCfg } from "./flow-util/edge/edge.js";
import { getCustomNodeCfg } from "./flow-util/node/customNode.js";
import { getStartNodeCfg } from "./flow-util/node/startNode.js";
import {
  getDragCreateEdgeOpt,
  buttonClick,
  getClickCreateEdgeOpt,
  getDragCreateNodeOpt,
  nodeClick,
  getDeleteEdgeOpt,
} from "./flow-util/behavior/index.js";
// DESC: shallowRef 非常重要，因为 g6 无法共享 proxy 构造出来的数据
import { shallowRef, ref, provide, inject } from "vue";
import { g6Config } from "./flow-util/config.ts";
import { getNodeUUID, getUUID } from "@/utils";
import { validateNode, validateXGraph } from "./validateXGraph.ts";
import { updateVarNode } from "./flow-util/node/utils.js";
import demo from "./demo.json";
import {
  updateAllConditionNodesBranchContent,
  updateAllEndReplyNodeContent,
  updateAllInterfaceCallNodeParams,
} from "./flow-util/node/node-utils/updateAllConditionNodesBranchContent";
import { systemVarsPool } from "@/utils/const";
import { createBranchMenu } from "./flow-util/menu/createBranchMenu";
import { FALLBACK_ERROR } from "../components/const";

export default {
  name: "QaTree",

  components: {
    // CenterFocusStrongIcon,
    // SaveIcon,
    // GestureApplauseIcon,
  },

  props: {
    gConfig: {
      type: Object,
      default: () => ({}),
    },
    qaTreeDisabled: {
      type: Boolean,
      default: false,
    },
    initJson: {
      type: String,
      default: "{}",
    },
  },
  graphNodes: [],
  graphEdges: [],
  emits: ["graphEvent"],
  setup(props, { emit }) {
    const xGraph = shallowRef(null);
    const variablePool = ref([]);
    const changedVar = ref({});
    const taskType = inject("taskType", "");
    const getTaskFlows = inject("getTaskFlows", ref());

    // 变量ID映射列表：用于智能任务流接口调用节点的变量管理
    // 格式：[{ id: "userdefine-xxx", nodeId: "node-xxx", varName: "output1" }]
    const varIdList = ref([]);
    // 启动节点变量列表：用于智能任务流启动节点变量的响应式同步
    // 格式：[{ name: "variable_1", type: "string" }]
    const inputVarList = ref([]);
    const updateVariablePool = (arr, { index, type, oldValue, newValue }) => {
      variablePool.value = cloneDeep(uniq(arr));
      if (type === "edit" || type === "delete") {
        changedVar.value = { oldValue, newValue };
      }
      updateVarNode(xGraph, { index, type, oldValue, newValue });
      updateAllInterfaceCallNodeParams(xGraph.value);
      updateAllEndReplyNodeContent(xGraph.value, systemVarsPool);
      // 更新所有条件判断节点的分支内容，当信息节点、系统变量、自定义变量发生变化时调用
      updateAllConditionNodesBranchContent(
        xGraph.value,
        systemVarsPool,
        variablePool.value,
        taskType,
      );
      emit("graphEvent", {
        type: "change",
        payload: {
          x6Data: xGraph.value.save(),
          userDefinedVar: variablePool.value,
        },
      });
    };
    const maxLimits = inject("maxLimits");

    provide("variablePool", variablePool);
    provide("updateVariablePool", updateVariablePool);
    provide("changedVar", changedVar);
    provide("xGraph", xGraph);
    // 提供变量ID映射列表给子组件（智能任务流使用）
    provide("varIdList", varIdList);
    // 提供启动节点变量列表给子组件（智能任务流使用）
    provide("inputVarList", inputVarList);

    return {
      xGraph: xGraph,
      xGraphLayout: null,
      variablePool,
      updateVariablePool,
      maxLimits,
      changedVar,
      varIdList,
      inputVarList,
      taskType,
      getTaskFlows,
    };
  },
  data() {
    return {
      demo,
    };
  },

  computed: {
    resizeDebounce() {
      return debounce(() => {
        this.resizePainter();
      }, 100);
    },
    baseDrawDataObj() {
      return JSON.parse(this.initJson);
    },
    centerGraph() {
      // 延迟, 给其他动画一些时间
      return debounce(this._centerGraph, 40);
    },
    nodeList() {
      return this.gConfig?.node?.nodeList ?? [];
    },
    startNodeType() {
      return this.gConfig?.node?.startNodeType ?? "startNode";
    },
  },
  watch: {
    // 启用停用
    qaTreeDisabled(value) {
      this.xGraph.setMode(value ? "custom" : "default");
    },
  },

  mounted() {
    this.init();
  },

  beforeUnmount() {
    console.log("beforeUnmount");
    window.removeEventListener("resize", this.resizeDebounce);
    this.xGraph.destroy();
  },

  methods: {
    async init() {
      this.registerItems();
      this.registerBehavior();
      this.initGraph();
      this.registerEvent(this.xGraph);
      window.addEventListener("resize", this.resizeDebounce);
      this.draw(this.baseDrawDataObj);
    },

    async validateXGraph() {
      return await validateXGraph(
        this.xGraph,
        {
          illicitRingType: ["replyMessageNode"],
        },
        this.maxLimits,
        this.getTaskFlows,
      );
    },
    async validateNode(node) {
      validateNode(node, this.maxLimits, this.xGraph);
    },

    async handlerSave(params) {
      const nodeFormValid = await this.$refs.editNode.validate();
      if (!nodeFormValid) {
        return this.xGraph.save();
      }

      this.$refs.editNode.close();
      const validRes = await this.validateXGraph();
      this.$emit("graphEvent", {
        type: "save",
        payload: {
          x6Data: this.xGraph.save(),
          params: {
            ...params,
            validRes,
            userDefinedVar: this.variablePool,
            varIdList: this.varIdList, // 保存变量ID映射列表（智能任务流使用）
          },
        },
      });
      return this.xGraph.save();
    },
    async organizeLayout(isManual) {
      // const chatData = this.xGraph.save();
      // const { predictLayout, confidence } = await GraphLayoutPredict.predict(
      //   chatData
      // );
      // DESC: 整理完画布删除 layout 避免影响后续布局
      this.xGraph.updateLayout(this.xGraphLayout);
      await new Promise((resolve) => {
        setTimeout(() => {
          resolve(1);
        }, 400);
      });
      this.xGraph.destroyLayout();
    },
    async handleClickLayout(isManual) {
      // 手动整理时才整理离散节点
      await this.organizeLayout(isManual);
      await this.xGraph.zoomTo(1, false, false);
      // 等上一个动画结束执行该动画
      this.centerGraph();
    },
    // 将图内容移动到中央位置
    _centerGraph() {
      this.xGraph.fitCenter(true, {
        duration: 100, // Number，一次动画的时长
        easing: "easeQuadInOut", // String，动画函数
      });
    },
    draw(baseDrawDataObj) {
      this.initData(baseDrawDataObj);

      this.xGraph.read({
        nodes: cloneDeep(this.graphNodes),
        edges: cloneDeep(this.graphEdges),
      });
      if (this.graphNodes.length !== 1) {
        this.xGraph.fitCenter(true, {});
      }
    },

    // 初始化 xGraph 的数据， 此步骤是把 baseDrawDataObj 读取到自己的 data 上。
    initData(baseDrawDataObj) {
      this.initNodes(baseDrawDataObj);
      this.initEdges(baseDrawDataObj);
      this.initVariablePool(baseDrawDataObj);
      // 初始化变量ID映射列表（智能任务流使用）
      this.initVarIdList(baseDrawDataObj);
    },

    initNodes(baseDrawDataObj) {
      // 如果是空画布, 新增开始节点
      const nodes = baseDrawDataObj.nodes;
      this.graphNodes = nodes || [];
      if (this.graphNodes.length === 0) {
        const nodeType = this.startNodeType;
        const nodeOpt = this.nodeList.find((node) => node.type === nodeType);
        const nodeName = `${nodeOpt.name}`;
        const container = document.getElementById("qa-tree-g6");
        const halfWidth = container.clientWidth / 2;
        this.graphNodes = [
          {
            id: getNodeUUID(),
            type: "start-node",
            x: halfWidth || 0,
            y: 150,
            label: nodeName,
            nodeData: {
              nodeData: {},
              nodeName,
              nodeType,
            },
          },
        ];
      }
    },
    initEdges(baseDrawDataObj) {
      const edges = baseDrawDataObj.edges;
      this.graphEdges = edges || [];
    },
    initVariablePool(baseDrawDataObj) {
      const variablePool = baseDrawDataObj.userDefinedVar || [];
      const startNodeVariables = (baseDrawDataObj.nodes || [])
        .filter((node) => node?.nodeData?.nodeType === "startNode")
        .flatMap((node) => node?.nodeData?.inputVariables || [])
        .map((item) => trim(item?.name || ""))
        .filter(
          (name) =>
            !!name && !systemVarsPool.some((systemVar) => systemVar.value === name),
        );
      this.variablePool = uniq([...variablePool, ...startNodeVariables]);
    },

    // 初始化变量ID映射列表（仅用于智能任务流）
    initVarIdList(baseDrawDataObj) {
      // 清空现有列表
      this.varIdList = [];

      const savedVarIdList = baseDrawDataObj.varIdList;

      if (
        savedVarIdList &&
        Array.isArray(savedVarIdList) &&
        savedVarIdList.length > 0
      ) {
        // 场景1：有保存的映射数据，直接恢复
        this.varIdList = savedVarIdList.filter(
          (item) =>
            item.id &&
            item.nodeId &&
            item.varName &&
            item.id.startsWith("userdefine-"),
        );
      } else {
        // 场景2：没有映射数据（旧数据或新流程），从节点重建映射
        const nodes = baseDrawDataObj.nodes || [];
        nodes.forEach((node) => {
          const nodeData = node.nodeData;
          // 只处理智能任务流的接口调用节点
          if (
            nodeData?.nodeType === "interfaceInvocationNode" &&
            nodeData.returns &&
            Array.isArray(nodeData.returns)
          ) {
            nodeData.returns.forEach((ret) => {
              if (
                ret.variable_id &&
                ret.key &&
                ret.variable_id.startsWith("userdefine-")
              ) {
                this.varIdList.push({
                  id: ret.variable_id,
                  nodeId: node.id,
                  varName: ret.key,
                });
              }
            });
          }
        });
      }
    },
    registerItems() {
      const edgeTypes = [
        { name: "line" },
        { name: "polyline" },
        { name: "arc" },
        { name: "quadratic" },
        { name: "cubic" },
        { name: "cubic-vertical" },
        { name: "cubic-horizontal" },
        { name: "loop" },
      ];
      edgeTypes.forEach((opt) => {
        const { name } = opt;
        const config = getEdgeDefineCfg(name);

        g6registerEdge(
          "custom:" + name,
          config.edgeDefinition,
          config.extendShapeType,
        );
      });
      // console.log(this.gConfig);

      const styleMaps = fromPairs(
        map(this.nodeList, (v) => [v.type, v.styles]),
      );

      g6registerNode(
        "custom-node",
        getCustomNodeCfg({
          styleMaps,
        }),
        "single-node",
      );

      g6registerNode(
        "start-node",
        getStartNodeCfg({ styleMaps }),
        "single-node",
        // "rect"
      );
    },

    registerBehavior() {
      g6registerBehavior(
        "delete-edge",
        getDeleteEdgeOpt({
          cfg: this.gConfig.edge.deleteEdgeBehavior,
        }),
      );

      // node 的点击事件
      g6registerBehavior("node-click", nodeClick);

      // 按钮的点击事件
      g6registerBehavior("node-button-click", buttonClick);

      // 拖拽左侧 DOM 生成新 node
      g6registerBehavior(
        "drag-create-node",
        getDragCreateNodeOpt({
          startNodeType: this.startNodeType,
          nodeList: this.nodeList,
          ...this.gConfig.node.createNodeBehavior,
        }),
      );

      // 拖拽 node 末尾圆点生成 edge
      g6registerBehavior(
        "drag-create-edge",
        getDragCreateEdgeOpt(this.gConfig.edge.createEdgeBehavior),
      );

      // 点击 node 末尾圆点生成 edge
      g6registerBehavior(
        "click-create-edge",
        getClickCreateEdgeOpt(this.gConfig.edge.createEdgeBehavior),
      );
    },
    registerEvent(graph) {
      // 初次渲染
      graph.on("afterrender", () => {
        console.log("afterrender11");

        setTimeout(() => {
          try {
            const findNode = this.xGraph.find("node", (node) => {
              return node.get("type") === "start-node";
            });
            if (findNode) {
              this.xGraph.focusItem(findNode, true);
            }
            this.validateXGraph();
            // TODO: 查下这个设置有什么用
            // 查过了，没什么用，用来设置刷新策略，默认就是 true
            // https://github.com/antvis/G6/issues/2193
            // 实际上，所有的残留，都是自己设置错误导致的。
            // this.xGraph.get("canvas").set("localRefresh", true);
          } catch (error) {
            console.log(error);
          }
        }, 400);
      });

      graph.on("edge:mouseenter", ({ item }) => {
        // console.log("edge:mouseenter", item);
        graph.setItemState(item, "active", true);
        item.toFront();
      });
      graph.on("edge:mouseleave", ({ item }) => {
        graph.setItemState(item, "active", false);
        item.toBack();
      });
      graph.on("node:mouseenter", ({ item }) => {
        // active 表示 hover 状态
        graph.setItemState(item, "active", true);
      });
      graph.on("node:mouseleave", ({ item }) => {
        // active 表示 hover 状态
        graph.setItemState(item, "active", false);
      });

      graph.on("xNode:clickNode", (ev) => {
        this.editNode(ev);
      });

      graph.on("xNode:buttonClick", (ev) => {
        const { target, item } = ev;
        const targetName = target.get("name") || "";
        const buttonType = /button:(.+)/.exec(targetName)[1];
        console.log(buttonType);
        if (buttonType === "delete") {
          // 删除节点，要把节点的上下边都给删除
          this.deleteNode(ev);
        }
        if (buttonType === "copy") {
          this.copyNode(ev);
        }
        if (buttonType === "edit") {
          this.editNode(ev);
        }
      });

      graph.on("xEdge:addOrUpdateEnd", () => {
        console.log("xEdge:addOrUpdateEnd");
        this.validateXGraph();
        this.triggerChange();
      });
      graph.on("xEdge:updateEdgeCfg", ({ item, type }) => {
        console.log("xEdge:updateEdgeCfg", item, type);
        this.handleInterfaceMenuChange(item, type);
        this.validateXGraph();
        this.triggerChange();
      });

      graph.on("xEdge:removeItem", () => {
        console.log("xEdge:removeItem");
        this.validateXGraph();
        this.triggerChange();
      });

      graph.on("dragCreateNode", (params) => {
        console.log(params);
        const newNode = this.createNode(
          params.nodeType,
          params.position,
          params.nodeData,
        );
        // 新增完，不执行全部验证，只执行部分验证
        // this.validateXGraph();

        // 新增完，执行节点验证
        this.validateNode(newNode);
        this.triggerChange();
      });

      graph.on("click", (e) => {
        console.log("canvas:click");
        if (!e.item) {
          this.closeAllDialog();
        }
      });
    },
    triggerChange() {
      updateAllInterfaceCallNodeParams(this.xGraph);
      updateAllEndReplyNodeContent(this.xGraph, systemVarsPool);
      // 更新所有条件判断节点的分支内容，当信息节点、系统变量、自定义变量发生变化时调用
      updateAllConditionNodesBranchContent(
        this.xGraph,
        systemVarsPool,
        this.variablePool,
        this.taskType,
      );
      this.$emit("graphEvent", {
        type: "change",
        payload: {
          x6Data: this.xGraph.save(),
          userDefinedVar: this.variablePool,
        },
      });
    },
    initGraph() {
      const qaTreeG6Dom = document.getElementById("qa-tree-g6");
      const painterHeight = parseInt(getComputedStyle(qaTreeG6Dom).height);
      const painterWidth = parseInt(getComputedStyle(qaTreeG6Dom).width);
      const plugins = [
        (() => {
          const minimapOpt = this.gConfig.minimap;
          if (minimapOpt === true) {
            return new g6Minimap({
              container: "minimap",
              className: "minimap",
              type: "keyShape",
              size: [263, 136],
            });
          }
          if (minimapOpt) {
            return new g6Minimap({
              container: "minimap",
              className: "minimap",
              ...minimapOpt,
            });
          }
        })(),
        (() => {
          const oldOnMenuShow = g6Menu.prototype.onMenuShow;
          g6Menu.prototype.onMenuShow = function (evt) {
            const newOnMenuShow = oldOnMenuShow.bind(this);
            if (evt?.item?.destroyed) {
              this.onMenuHide();
              return;
            } else {
              return newOnMenuShow(evt);
            }
          };

          return new g6Menu({
            offsetX: 6,
            offsetY: 10,
            itemTypes: ["edge"],
            trigger: "click",
            getContent(e) {
              console.log(e);
              const edge = e.item;
              if (edge) {
                const edgeStartNodeData = edge.getSource().getModel().nodeData;
                const edgeStartNodeBranchId =
                  edge.getModel().edgeData?.branchId;
                const branches = edgeStartNodeData.branches;

                return createBranchMenu(branches, edgeStartNodeBranchId);
              }
            },
            handleMenuClick: (target, item) => {
              const edgeRelationName =
                target.getAttribute("data-edge-relation-name") || "";
              const type = target.getAttribute("data-type") || "";
              const edgeRelationId = target.getAttribute(
                "data-edge-relation-id",
              );
              if (!item.destroyed && edgeRelationId) {
                item.update({
                  label: edgeRelationName + " ▼",
                  edgeData: {
                    branchId: edgeRelationId,
                  },
                });
                this.xGraph.emit("xEdge:updateEdgeCfg", { item, type });
              }
            },
            shouldBegin(e) {
              const item = e.target;
              if (!e.item.destroyed) {
                if (
                  (item.get("name") === "text-shape" &&
                    item.get("className") === "edge-label") ||
                  item.get("name") === "text-bg-shape"
                ) {
                  const edge = e.item;
                  const edgeStartNodeData = edge
                    .getSource()
                    .getModel().nodeData;
                  if (edgeStartNodeData.branches?.length) {
                    return true;
                  }
                }
              }
            },
          });
        })(),
        (() => {
          const tooltip = new g6Tooltip({
            offsetX: 6,
            offsetY: 10,
            getContent(e) {
              const node = e.item;
              const errorData = node.getModel().errorData || [];

              const outDiv = document.createElement("div");
              // outDiv.style.width = "180px";
              outDiv.innerHTML =
                "<ul>" +
                errorData
                  .map((v) => {
                    return `<li>${v.value || "&nbsp;"}</li>`;
                  })
                  .join("") +
                "</ul>";
              return outDiv;
            },
            itemTypes: ["node"],
            trigger: "mouseenter",
            shouldBegin(e) {
              const item = e.target;
              if (!e.item.destroyed) {
                if (item.get("name") === "error-icon") {
                  const errorData = e.item.getModel().errorData || [];
                  if (errorData.length > 0) {
                    return true;
                  }
                }
              }
            },
          });
          return tooltip;
        })(),
      ].filter((v) => v);

      const cfg = merge({}, g6Config, {
        container: "qa-tree-g6",
        width: painterWidth,
        defaultEdge: {
          type: "custom:" + g6Config.defaultEdge.type,
        },
        height: painterHeight,
        plugins,
      });
      unset(cfg, "layout");

      this.xGraphLayout = g6Config.layout;
      this.xGraph = new g6Graph(cfg);

      // 初始化数量
      this.xGraph.nodeNum = {};
    },
    async resizePainter() {
      const painterHeight = parseInt(
        getComputedStyle(this.$refs.painter).height,
      );
      const painterWidth = parseInt(getComputedStyle(this.$refs.painter).width);
      this.xGraph.changeSize(painterWidth, painterHeight);
      this.xGraph.zoomTo(1, false, false);
      // 给上面动画一些时间
      await new Promise((resolve) => {
        setTimeout(() => {
          resolve(1);
        }, 650);
      });
      this.centerGraph();
    },

    // edge 的终点更新
    afterUpdateEdge({ item }) {
      // 拿到 edge 的 起点，开始验证它有几条 edge
      // 添加连线后整理画布
      // this.handleClickLayout();
    },

    deleteNode(ev) {
      const { item } = ev;

      // 原有的删除逻辑
      // Tip: 这竟然是一个响应式对象，要先获取长度，再删除，否则长度为 0
      const edges = item.getEdges();
      const edgesLength = edges.length;
      edges.forEach((edge) => {
        this.xGraph.removeItem(edge);
      });
      this.xGraph.removeItem(item);
      // 1
      console.log(edgesLength);
      // DESC: 性能优化
      // 如果有连线，则进行全图验证。否则可以跳过
      if (edgesLength > 0) {
        this.validateXGraph();
      }
      this.triggerChange();
    },

    async copyNode(ev) {
      const { item } = ev;
      const model = item.getModel();
      const r = 150;
      const angle = [-60, 60];
      const arc = random(
        toInteger(-angle[0] * Math.PI),
        toInteger(-angle[1] * Math.PI),
      );
      const dx = r * Math.cos(arc / 180);
      const dy = r * Math.sin(arc / 180);
      await Promise.resolve(1);
      const copiedNodeData = cloneDeep(model.nodeData);

      // 用于映射旧的 variable_id 到新的 variable_id
      const varIdMapping = {};

      // 接口调用节点的输出参数需要生成新的 variable_id，避免复制后 ID 重复
      if (
        copiedNodeData.nodeType === "interfaceInvocationNode" &&
        Array.isArray(copiedNodeData.returns)
      ) {
        copiedNodeData.returns = copiedNodeData.returns.map((item) => {
          if (item.variable_id) {
            const newVariableId = `userdefine-${getUUID()}`;
            varIdMapping[item.variable_id] = newVariableId;
            return {
              ...item,
              variable_id: newVariableId,
            };
          }
          return item;
        });
      }

      const newNode = this.createNode(
        model.nodeData.nodeType,
        {
          x: model.x + dx,
          y: model.y + dy,
        },
        copiedNodeData,
      );

      // 复制节点后，同步更新 varIdList（智能任务流使用）
      // 将原节点的变量映射复制到新节点，使用新生成的 variable_id
      if (copiedNodeData.nodeType === "interfaceInvocationNode") {
        const originalReturns = model.nodeData.returns || [];
        const newNodeId = newNode.getModel().id;

        originalReturns.forEach((originalReturn) => {
          if (originalReturn.variable_id && varIdMapping[originalReturn.variable_id]) {
            // 从 varIdList 中找到原节点对应的变量
            const originalVarMapping = this.varIdList.find(
              (v) => v.id === originalReturn.variable_id,
            );

            if (originalVarMapping) {
              // 为新节点创建变量映射
              this.varIdList.push({
                id: varIdMapping[originalReturn.variable_id],
                nodeId: newNodeId,
                varName: originalVarMapping.varName,
              });
            }
          }
        });
      }

      this.triggerChange();
    },

    createNode(nodeType, position, nodeData) {
      const nodeOpt = this.nodeList.find((node) => node.type === nodeType);

      // 找到所有同类型节点，提取它们的编号
      const existingNodes =
        this.xGraph.findAll("node", (node) => {
          return get(node.getModel(), "nodeData.nodeType") === nodeType;
        }) || [];

      // 从节点名称中提取编号，例如"条件判断1" -> 1
      // 转义节点名称中的特殊字符，用于正则表达式
      const escapedName = nodeOpt.name.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
      const usedNumbers = existingNodes
        .map((node) => {
          const nodeName = get(node.getModel(), "nodeData.nodeName", "");
          const match = nodeName.match(new RegExp(`^${escapedName}(\\d+)$`));
          return match ? parseInt(match[1], 10) : null;
        })
        .filter((num) => num !== null)
        .sort((a, b) => a - b);

      // 找到最小的未使用的编号（从1开始）
      let nextNum = 1;
      for (const num of usedNumbers) {
        if (num === nextNum) {
          nextNum++;
        } else {
          break;
        }
      }

      const nodeName = `${nodeOpt.name}${nextNum}`;
      const newNode = this.xGraph.addItem("node", {
        id: getNodeUUID(),
        type: nodeType === this.startNodeType ? "start-node" : "custom-node",
        x: position.x,
        y: position.y,
        label: nodeName,
        nodeData: {
          ...nodeData,
          nodeName,
          nodeType,
        },
      });
      newNode.toFront();
      // 新增完，不执行全部验证，只执行部分验证
      // this.validateXGraph();

      // 新增完，执行节点验证
      this.validateNode(newNode);
      return newNode;
    },

    highLightNodeEdges({ item }) {
      this.cancelHighLightAllEdges();

      const edges = item.getEdges();
      edges.forEach((edge) => this.xGraph.setItemState(edge, "running", true));
    },
    cancelHighLightAllEdges() {
      this.xGraph.stopAnimate();
      const edges = this.xGraph.getEdges();
      edges.forEach((edge) => this.xGraph.setItemState(edge, "running", false));
    },
    highLightNodePathEdges({ item }) {
      this.cancelHighLightAllEdges();
      const allEdges = [];
      const allNodes = [];
      let nodes = [item];
      let edgesArr = [];
      for (let i = 0; i < 20; i++) {
        for (const node of nodes) {
          // if (allNodes.includes(node)) continue;
          allNodes.push(node);
          const cEdges = node.getInEdges();
          edgesArr.push(cEdges);
        }
        nodes = [];
        for (const edges of edgesArr) {
          for (const edge of edges) {
            if (allEdges.includes(edge)) continue;
            allEdges.push(edge);
            nodes.push(edge.getSource());
          }
        }
        edgesArr = [];
      }

      allEdges.forEach((edge) =>
        this.xGraph.setItemState(edge, "running", true),
      );
    },
    toggleEdgeType() {
      const edgeTypes = [
        "line",
        "polyline",
        "arc",
        "quadratic",
        "cubic",
        "cubic-vertical",
        "cubic-horizontal",
        "loop",
      ];
      const currentEdgeType = this.graphEdges[0]?.type.match();
      const allData = this.xGraph.save();
      const currentEdgeType1 = allData.edges[0].type.match(/custom:(.+)/)[1];
      const nextType =
        edgeTypes[
          (edgeTypes.findIndex((v) => v === currentEdgeType1) + 1) %
            edgeTypes.length
        ];

      this.xGraph.read({
        ...allData,
        edges: allData.edges.map((v) => {
          return {
            ...v,
            type: "custom:" + nextType,
          };
        }),
      });
      console.log(currentEdgeType, currentEdgeType1, nextType);
    },
    editNode(ev) {
      const node = ev.item;
      this.$refs.editNode.open(node.getModel());
    },
    closeAllDialog() {
      // this.$refs.editNode.close();
    },
    handlerEditNodeDialogClose(newModelOpt) {
      const id = newModelOpt.id;
      const node = this.xGraph.findById(id);
      if (!node) return;
      this.handlerFallbackSwitchChange(newModelOpt);
      // 如果编辑的节点有连线，则执行全部图形验证
      if (node.getEdges().length > 0) {
        this.validateXGraph();
      } else {
        this.validateNode(node);
      }
    },
    handleInterfaceMenuChange(edge, menuType) {
      const source = edge.getSource();
      const sourceModel = source.getModel();
      const {
        nodeData: { nodeType },
      } = sourceModel;
      if ("interfaceInvocationNode" === nodeType) {
        edge.update({ isFallback: menuType === `${FALLBACK_ERROR}` ? 1 : 0 });
      }
    },
    handlerFallbackSwitchChange(newModelOpt) {
      const nodeType = newModelOpt.nodeData.nodeType;
      const fallbackSwitch = newModelOpt.nodeData.fallbackSwitch;
      const branches = newModelOpt.nodeData.branches;

      if (nodeType === "interfaceInvocationNode") {
        const edges = this.xGraph
          .getEdges()
          .filter((edge) => edge.getModel().source === newModelOpt.id);

        // 只有一条线且不是 异常处理的
        if (
          fallbackSwitch &&
          edges.length === 1 &&
          !edges[0].getModel().isFallback
        ) {
          edges.forEach((edge) => {
            edge.update({
              label: branches[0].content + " ▼",
              edgeData: { branchId: branches[0].id },
            });
          });
        }
      }
    },
    // 提交编辑 node 的命令
    handlerEditNodeSubmit(newModelOpt) {
      const {
        nodeData: { nodeType, branches: newBranches },
      } = newModelOpt;
      const id = newModelOpt.id;
      const node = this.xGraph.findById(id);
      if (!node) return;

      node.update(newModelOpt);
      const sourceOutEdges = node.getOutEdges();
      const branches = get(newModelOpt, "nodeData.branches", []);

      let needValidateAllGraph = false;
      // 编辑出点 edge 的数据
      sourceOutEdges.forEach((edge) => {
        const edgeModel = edge.getModel();
        const branchId = edgeModel?.edgeData?.branchId;
        if (branchId) {
          const newRelationOpt = branches.find((v) => v.id === branchId);
          if (newRelationOpt && newRelationOpt.id) {
            edge.update({
              label: newRelationOpt.content + " ▼",
              edgeData: {
                branchId: newRelationOpt.id,
              },
            });
          } else {
            this.xGraph.removeItem(edge);
            needValidateAllGraph = true;
          }
        }
      });

      if (needValidateAllGraph) {
        this.validateXGraph();
      }
      this.triggerChange();
    },
  },
};
</script>

<style lang="less" scoped>
.qa-tree-container {
  position: relative;
  height: 100%;
  width: 100%;
  #qa-tree-g6 {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    overflow: hidden;
    background-color: #ebeff5;
  }
  .operation {
    background: white;
    position: absolute;
    left: 24px;
    bottom: 20px;
    padding: 6px;
    display: flex;
    gap: 6px;
    .button {
      background: white;
      box-shadow: none;
      width: 33px;
      height: 33px;
    }
  }
}
</style>
<style lang="less">
.g6-component-contextmenu,
.g6-component-tooltip {
  box-shadow: none;
  ul {
    list-style: none;
    padding: 0;
    margin: 0;
    li + li {
      margin-top: 20px;
    }
    li {
      cursor: pointer;
      &:hover {
        color: aqua;
      }
    }
  }
}

#qa-tree-g6 .g6-component-contextmenu {
  background: unset;
  border-radius: unset;
  box-shadow: unset;
  padding: 0;
  border: unset;
}
</style>
